<template>
  <v-dialog
    v-model="dialog"
    max-width="500"
    content-class="sc-modal sc-modal--sm"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        small
        text
        class="admin-add-btn"
        v-bind="attrs"
        v-on="on"
      >
        <v-icon small class="mr-1">mdi-plus</v-icon>
        Nova categoria
      </v-btn>
    </template>

    <v-card v-if="dialog" flat class="sc-modal__card">
      <v-btn icon class="sc-modal__close" @click="close">
        <v-icon>mdi-close</v-icon>
      </v-btn>

      <div class="sc-modal__header">
        <v-icon color="primary" class="mr-3">mdi-shape-plus</v-icon>
        <div>
          <span class="sc-modal__title">Cadastrar categoria</span>
          <span class="sc-modal__subtitle">Crie uma nova categoria de enquete</span>
        </div>
      </div>

      <div class="sc-modal__body">
        <div class="sc-modal__field">
          <label class="sc-modal__field-label">Portal</label>
          <v-select
            v-model="selectedPortal"
            :items="portais"
            dense solo flat
            hide-details
            item-text="dsc_nome"
            item-value="id"
            return-object
            background-color="surface_tertiary"
            placeholder="Escolha o portal"
          />
        </div>
        <div class="sc-modal__field">
          <label class="sc-modal__field-label">Nome da categoria</label>
          <v-text-field
            solo flat dense
            hide-details
            v-model="dsc_nome_categoria"
            background-color="surface_tertiary"
            placeholder="Ex: Votação BBB, Enquete GE..."
          />
        </div>
        <div class="sc-modal__field">
          <label class="sc-modal__field-label">Chave backstage</label>
          <v-text-field
            solo flat dense
            hide-details
            v-model="dsc_chave_backstage"
            background-color="surface_tertiary"
            placeholder="Chave de integração"
          />
        </div>
      </div>

      <div class="sc-modal__footer">
        <v-btn text @click="close" class="modal-btn-cancel">Cancelar</v-btn>
        <v-btn
          color="primary"
          @click.prevent="cadastrarCategoria"
          :loading="loading"
          class="modal-btn-confirm"
        >
          <v-icon small class="mr-1">mdi-check</v-icon>
          Cadastrar
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { apiClient } from "@/services/api";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "ModalCadastrarCategoriaEnquete",
  data() {
    return {
      dialog: false,
      loading: false,
      dsc_nome_categoria: null,
      dsc_chave_backstage: null,
      selectedPortal: null,
    };
  },
  watch: {
    dialog(open) {
      if (open) this.clearFormData();
    },
  },
  created() {
    this.getPortais();
  },
  computed: {
    ...mapGetters({
      portais: "enquetes/getterPortaisEnquetes",
    }),
  },
  methods: {
    ...mapActions({
      getCategoriasEnquetes: "enquetes/getCategoriasEnquetes",
      getPortais: "enquetes/getPortaisEnquetes",
    }),
    close() {
      this.$emit("close");
      this.dialog = false;
      this.clearFormData();
    },
    clearFormData() {
      this.dsc_nome_categoria = null;
      this.dsc_chave_backstage = null;
      this.selectedPortal = null;
    },
    async cadastrarCategoria() {
      if (!this.selectedPortal) {
        this.$toast.info("Selecione o portal da categoria");
        return;
      }
      if (!this.dsc_nome_categoria) {
        this.$toast.info("Informe o nome da categoria");
        return;
      }
      if (!this.dsc_chave_backstage) {
        this.$toast.info("Informe a chave backstage da categoria");
        return;
      }

      this.loading = true;
      try {
        await apiClient.post("/enquetes/categorias", {
          id_portal: this.selectedPortal.id,
          dsc_nome_categoria: this.dsc_nome_categoria,
          dsc_chave_backstage: this.dsc_chave_backstage,
        });
        this.$toast.success("Categoria criada com sucesso");
        this.close();
        await this.getCategoriasEnquetes({ page: 1, size: 100 });
      } catch (error) {
        this.$toast.error("Erro ao criar categoria.");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
